module.exports = __webpack_public_path__ + "img/logo2.629325c3.png";